// Bridge: reuse the project details implementation for project iteration listing.
import ProjectDetails from "../projects/pages/ProjectDetails";

export default ProjectDetails;
